module.exports = __webpack_public_path__ + "static/media/CaptainAmerica.5cee8152.jpg";